import { Card, Grid2, Typography } from "@mui/material";
import dayjs from "dayjs";
import { moneyCommaSeparator } from "utils/helpers";

interface PortfolioCardProps {
  companyDetails?: any;
}

function CompanyCard(props: PortfolioCardProps) {
  const { companyDetails } = props;

  const fields = [
    {
      name: "Company Name",
      value: companyDetails?.data?.name || "-",
      grid: 5,
    },
    {
      name: "ISIN",
      value: companyDetails?.data?.isinCode || "-",
      grid: 2.33,
    },
    {
      name: "NSE Code",
      value: companyDetails?.data?.nseCode || "-",
      grid: 2.33,
    },
    {
      name: "BSE Code",
      value: companyDetails?.data?.bseCode || "-",
      grid: 2.33,
    },
  ];

  return (
    <Card style={{ margin: 0 }}>
      <Grid2 container spacing={2}>
        <Grid2
          container
          size={9}
          mb={2}
          className="text-[#006480] text-[25px] mt-[-6px] font-bold relative"
        >
          <Grid2 display="flex" alignItems="center" columnGap={1}>
            <Typography fontSize={25} fontWeight={700}>
              {companyDetails?.data?.name}:
            </Typography>

            {companyDetails?.data?.instType === "OPTIONS" && (
              <Typography fontSize={20} fontWeight={600}>
                {dayjs(companyDetails?.data?.expiryDate).format("DD-MM-YYYY")}
              </Typography>
            )}
          </Grid2>

          <Grid2 ml={1}>
            <Typography
              fontSize={25}
              fontWeight={700}
              sx={{ color: "var(--primary-700)" }}
            >
              {moneyCommaSeparator(Number(companyDetails?.data?.cmp))}
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          size={3}
          display={"flex"}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
          <Typography fontSize={14} fontWeight={500}>
            {companyDetails?.data?.timestamp}
          </Typography>
        </Grid2>
        <Grid2 container size={12} spacing={1}>
          {fields?.map((dataItem, index: number) => (
            <Grid2 size={dataItem.grid} key={index}>
              <Card
                sx={{
                  margin: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  backgroundColor: "var(--primary-50)",
                  color: "var(--primary-900)",
                  borderRadius: 2,
                  boxShadow: 0.5,
                }}
              >
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  sx={{ color: "var(--primary-700)" }}
                >
                  {dataItem.name}
                </Typography>
                <Typography fontSize={14} fontWeight={700}>
                  {dataItem.value}
                </Typography>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
    </Card>
  );
}

export default CompanyCard;
